import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "image-tagger" }
const _hoisted_2 = ["src"]

import { onMounted, ref } from 'vue'
import axios from 'axios'
import { notification } from 'ant-design-vue'
import MediaItem, { Tag } from '@/types/mediaItem'

interface Props {
  visible:boolean
  file:MediaItem
  surveyId?:number|null
  deliveryId?:number|null
  surveyAnswerId:number|null
  taggedIssueId:number|null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IssueTagger',
  props: {
    visible: { type: Boolean },
    file: null,
    surveyId: null,
    deliveryId: null,
    surveyAnswerId: null,
    taggedIssueId: null
  },
  emits: ['tagSaved', 'closeTagger'],
  setup(__props: any, { emit }) {

const props = __props as {
  visible:boolean
  file:MediaItem
  surveyId?:number|null
  deliveryId?:number|null
  surveyAnswerId:number|null
  taggedIssueId:number|null
};




const loading = ref(false)

const file = ref<MediaItem|null>(null)
const newTag = ref<Tag>({ position: { x: 0, y: 0 }, delivery_id: null, survey_id: null, survey_answer_id: null, tagged_issue_id: null })

const tags = ref<Tag[]>([])

onMounted(() => {
  file.value = props.file
  tags.value = props.file.tags
  newTag.value.survey_answer_id = props.surveyAnswerId
  newTag.value.tagged_issue_id = props.taggedIssueId

  if (props.surveyId) {
    newTag.value.survey_id = props.surveyId
  } else if (props.deliveryId) {
    newTag.value.delivery_id = props.deliveryId
  }
})

function setPin (event:MouseEvent|null = null) : void {
  if (event) {
    const target = event.target as Element
    const rect = target.getBoundingClientRect()
    newTag.value.position.x = ((event.clientX - rect.left) / rect.width) * 100
    newTag.value.position.y = ((event.clientY - rect.top) / rect.height) * 100
  }
}

function addPin () : void {
  loading.value = true
  axios.post(process.env.VUE_APP_API_URL + '/issues/tag/' + file.value?.id, { tag: newTag.value }).then((r) => {
    file.value = r.data.data
    closeTagger()
  }).catch(() => {
    notification.error({ message: 'Melding NIET aangemaakt!', description: 'Melding NIET aangemaakt. Probeer het later nogmaals.', duration: 0 })
  }).finally(() => {
    loading.value = false
  })
}

function closeTagger () : void {
  emit('closeTagger', file.value)
}

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    title: "Tag toevoegen",
    visible: props.visible,
    "ok-text": "Tag opslaan",
    "ok-button-props": { loading: loading.value, disabled: loading.value },
    onOk: addPin,
    "cancel-text": "Annuleren",
    onCancel: closeTagger
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_row, { gutter: [16,16] }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "image-container",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (setPin($event)))
                }, [
                  _createElementVNode("img", {
                    src: file.value?.url
                  }, null, 8, _hoisted_2),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag, index) => {
                    return (_openBlock(), _createBlock(_component_a_tooltip, {
                      placement: "top",
                      key: index,
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                    }, {
                      title: _withCtx(() => [
                        _createTextVNode("Servicemelding #" + _toDisplayString(tag.tagged_issue_id), 1)
                      ]),
                      default: _withCtx(() => [
                        (tag.tagged_issue_id === newTag.value.tagged_issue_id)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "tag",
                              style: _normalizeStyle({ left: `calc(${tag.position.x}%)`, top: `calc(${tag.position.y}%)` })
                            }, null, 4))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  (newTag.value.position.x && newTag.value.position.y)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "tag",
                        style: _normalizeStyle({ left: `calc(${newTag.value.position.x}%)`, top: `calc(${newTag.value.position.y}%)` })
                      }, null, 4))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["visible", "ok-button-props"]))
}
}

})